import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';
import { logError } from '@shared/services/errorLoggingService';
import './index.css';

// Global error handlers for non-React errors
window.onerror = (_message, source, lineno, colno, error) => {
  logError(error ?? new Error(String(_message)), {
    action: 'window.onerror',
    extra: { source, line: lineno, col: colno },
  });
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  logError(event.reason ?? new Error('Unhandled promise rejection'), {
    action: 'unhandledrejection',
  });
};

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
